import React from "react";
import ReactApexChart from "react-apexcharts";

const PatientDonutChart = ({ patients }) => {
  // 1. Calculate the counts for each gender
  const maleCount = patients.filter(p => p.gender === 'male').length;
  const femaleCount = patients.filter(p => p.gender === 'female').length;
  const childCount = patients.filter(p => {
    const age = parseInt(p.age);
    return !isNaN(age) && age < 18;
  }).length;

  const chartState = {
    series: [maleCount, femaleCount, childCount],
    options: {
      chart: {
        type: 'donut',
      },
      legend: {
        show: false,
      },
      colors: ['#465DFF', '#6AC75A', '#67BAF1'],
      labels: ['Male', 'Female', 'Child'],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "70%",
            labels: {
              show: true,
              total: {
                show: true,
                label: 'Total Patients',
                fontSize: '18px',
                fontWeight: 600,
                color: '#373d3f',
              }
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 150 },
            legend: { position: "bottom" },
          },
        },
      ],
    },
  };

  return (
    <div>
      <div id="chart" className="dashboard-donut-chart">
        <ReactApexChart
          options={chartState.options}
          series={chartState.series}
          type="donut"
          height={220}
        />
      </div>
    </div>
  );
};

export default PatientDonutChart;